var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "#0A8AEE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2461 53.4304L22.5712 40.7917C22.3901 40.6111 22.2465 40.3967 22.1485 40.1608C22.0504 39.9249 22 39.672 22 39.4167C22 39.1613 22.0504 38.9084 22.1485 38.6725C22.2465 38.4366 22.3901 38.2222 22.5712 38.0417L25.329 35.2917C25.5101 35.1111 25.7251 34.9679 25.9617 34.8702C26.1983 34.7724 26.4519 34.7221 26.708 34.7221C26.9641 34.7221 27.2176 34.7724 27.4542 34.8702C27.6908 34.9679 27.9058 35.1111 28.0869 35.2917L36.625 43.8055L54.9131 25.5696C55.0942 25.389 55.3092 25.2458 55.5458 25.148C55.7824 25.0503 56.0359 25 56.292 25C56.5481 25 56.8017 25.0503 57.0383 25.148C57.2749 25.2458 57.4899 25.389 57.671 25.5696L60.4288 28.3196C60.6099 28.5001 60.7535 28.7145 60.8515 28.9504C60.9496 29.1863 61 29.4392 61 29.6945C61 29.9499 60.9496 30.2028 60.8515 30.4387C60.7535 30.6746 60.6099 30.889 60.4288 31.0695L38.004 53.4304C37.8229 53.611 37.6079 53.7542 37.3713 53.852C37.1347 53.9497 36.8811 54 36.625 54C36.3689 54 36.1154 53.9497 35.8788 53.852C35.6422 53.7542 35.4272 53.611 35.2461 53.4304Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.38717016.svg";
export { ForwardRef as ReactComponent };